import type { Variants } from 'motion/react';

export const fadeUp = (reducedMotion: boolean): Variants => ({
  hidden: reducedMotion ? { opacity: 1, y: 0 } : { opacity: 0, y: 12 },
  visible: { opacity: 1, y: 0, transition: { duration: reducedMotion ? 0 : 0.35, ease: 'easeOut' } },
});

export const staggerContainer = (staggerChildren = 0.08, reducedMotion = false): Variants => ({
  hidden: {},
  visible: { transition: { staggerChildren: reducedMotion ? 0 : staggerChildren } },
});
